import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import OrderGrid from '@sophocles/views/sales/components/OrderGrid';

function OrderListView() {
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: t('warehouse.sales', 'Sales'), to: '/sales/orders' },
    { label: t('general.orders', 'Orders') },
  ];

  return (
    <AppNav flex notFullHeight loading={false} page="sales_orders">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar breadcrumbs={breadcrumbs} />
        <OrderGrid />
      </Box>
    </AppNav>
  );
}

export default OrderListView;
